module.exports = __webpack_public_path__ + "static/media/safety.8596ac93.txt";